<ng-template
  let-extraClass="extraClass"
  #topNav />

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'">
      <tidy-text
        [body]="('We accept ACH or Wire Transfer for payments over $500. When possible, please include your customer ID (' | translate) + customerId + (') on payments for faster processing.' | translate)" />
    </tidy-row>

    <tidy-card>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/send-money.svg'"
          class="title-size" />
        <tidy-text
          [title]="'ACH Instructions'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Please remit ACH payments to:'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Routing Number: 084106768'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Account Number: 700090723409801'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="'Beneficiary Info'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Tidy Services, Inc.'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'2093 Philadelphia Pike, #1446 Claymont, DE 19703'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="'Bank Info'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Column N.A.'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'1 Letterman Drive, Building A, Suite A4-700, San Francisco, CA 94129'" />
      </tidy-row>
    </tidy-card>

    <tidy-card>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/wire.svg'"
          class="title-size" />
        <tidy-text
          [title]="'Wire Instructions'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Please remit Wire payments to:'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Routing Number: 084106768'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Account Number: 700090723409801'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="'Beneficiary Info'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Tidy Services, Inc.'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'2093 Philadelphia Pike, #1446 Claymont, DE 19703'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="'Bank Info'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Column N.A.'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'1 Letterman Drive, Building A, Suite A4-700, San Francisco, CA 94129'" />
      </tidy-row>
    </tidy-card>

  </tidy-wrapper>
</ng-template>

<ion-content class="ion-content-right-column">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>
